export const devCheck = (): void => {
  (() => {
    const k = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    let s: string[] = [];

    function r() {
      const e = document.createElement('style');
      e.innerHTML = `@keyframes c{0%{filter:hue-rotate(0deg)}100%{filter:hue-rotate(360deg)}}body{animation:c 5s linear infinite}`;
      document.head.appendChild(e);
    }

    function l(e: HTMLElement) {
      const t = document.createElement('div');
      t.innerHTML = '*';
      Object.assign(t.style, {
        position: 'absolute',
        top: '-10px',
        left: `${Math.random() * 100}vw`,
        fontSize: `${Math.random() * 20 + 10}px`,
        color: 'red',
        textShadow: '0 0 5px rgba(255,0,0,0.8)',
        pointerEvents: 'none',
        opacity: Math.random().toString(),
      });
      e.appendChild(t);

      const n = Math.random() * 5 + 3;
      const o = (Math.random() - 0.5) * 50;
      t.animate([{ transform: `translate(${o}px,100vh)`, opacity: '0' }], { duration: n * 1000, easing: 'linear' });
      setTimeout(() => {
        t.remove();
        l(e);
      }, n * 1000);
    }

    function f() {
      const e = document.createElement('div');
      Object.assign(e.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        overflow: 'hidden',
        zIndex: '9999',
      });
      document.body.appendChild(e);
      for (let t = 0; t < 50; t += 1) l(e);
    }

    window.addEventListener('keydown', (e) => {
      s.push(e.key);
      s = s.slice(-k.length);
      if (JSON.stringify(s) === JSON.stringify(k)) {
        r();
        f();
        s = [];
      }
    });
  })();
};
